import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import RegistrationHeader from "@/components/auth/registration/Header.tsx";
import { cn } from "@edusogno/lib/utils";
import { RegisterUserInput } from "@/types";
import OutlinedInput from "@edusogno/inputs/outlined-input";
import RegistrationContent from "@/components/auth/registration/Content.tsx";
import RegistrationContainer from "@/components/auth/registration/Container.tsx";
import LoadingButton from "@edusogno/primitives/loading-button";
import AuthPageFooter from "@edusogno/layouts/auth-page-footer.js";

interface EmailProps {
  className?: string;
  onNext: () => void;
  isLoading?: boolean;
}

const RegistrationEmail = ({ className, onNext, isLoading }: EmailProps) => {
  const {
    formState: { errors },
    register,
  } = useFormContext<RegisterUserInput>();
  const { t } = useTranslation();

  return (
    <>
      <RegistrationContainer className={cn("h-full", className)}>
        <RegistrationHeader
          title={t("auth.registration.email_title")}
          subtitle={t("auth.registration.email_subtitle")}
          logo={"email"}
        />

        <RegistrationContent>
          <OutlinedInput
            label={t("auth.labels.email")}
            placeholder={"hello@you.com"}
            autoComplete={"off"}
            color={"grey"}
            // size={"lg"}
            type="email"
            {...register("email")}
            error={Boolean(errors.email?.message)}
          />
        </RegistrationContent>
      </RegistrationContainer>
      <AuthPageFooter>
        <LoadingButton
          size={"lg"}
          type="button"
          className="hidden w-full text-lg tracking-wide md:block"
          disabled={Boolean(errors?.email?.message)}
          onClick={() => onNext()}
          loading={isLoading}
        >
          {t("btns.next")}
        </LoadingButton>
        <LoadingButton
          size={"md"}
          type="button"
          className="block w-full text-lg tracking-wide md:hidden"
          disabled={Boolean(errors.email?.message)}
          loading={isLoading}
          onClick={() => onNext()}
        >
          {t("btns.next")}
        </LoadingButton>
      </AuthPageFooter>
    </>
  );
};

export default RegistrationEmail;